import GruposSKU from "./GruposSKU";

export default GruposSKU;
